import { FormBuilderComponent } from '@app/form-builder/form-builder.component'
import { ControlElement } from '@app/form-builder/interfaces/form.interface'
import { Component, OnInit, Input } from '@angular/core'
import { FormGroup } from '@angular/forms'

@Component({
    selector: 'form-layout',
    templateUrl: './form.component.html'
})
export class FormComponent implements OnInit {

    @Input() content: [ControlElement[], ControlElement[], ControlElement[], ControlElement[]]
    form: FormGroup

    constructor(private parentForm: FormBuilderComponent) {}

    ngOnInit() {
        this.form = this.parentForm.formGroup
    }

}